export default function HowItWorksPage() {
  const steps = [
    { n: "01", title: "Choose Your Procedure", desc: "Select from six systems tailored to each cosmetic procedure. Not sure? Try the Procedure Finder." },
    { n: "02", title: "Personalize Your Order", desc: "Add your surgery date. We time delivery to arrive 3–5 days beforehand." },
    { n: "03", title: "We Deliver", desc: "Your system ships in premium, understated packaging. Signature not required." },
    { n: "04", title: "Recover With Confidence", desc: "Follow a day-by-day protocol built with board-certified plastic surgeons." },
  ];

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-8 lg:px-16 py-20">
      <div className="eyebrow">Process</div>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-4 tracking-tight">How ALTA Works</h1>
      <p className="text-[#6B5757] mt-6 leading-relaxed max-w-2xl">
        A recovery experience should feel considered — not chaotic. Here's how we take you from booking your procedure to revealing your results.
      </p>
      <div className="mt-16 space-y-16">
        {steps.map((s) => (
          <div key={s.n} className="grid grid-cols-1 md:grid-cols-4 gap-6 border-t border-[#F0DFD0] pt-8">
            <div className="font-mono text-xs tracking-widest text-[#B85C56]">{s.n}</div>
            <div className="md:col-span-3">
              <h2 className="font-serif text-3xl">{s.title}</h2>
              <p className="text-[#6B5757] mt-3 leading-relaxed">{s.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
